import { request } from './client';
import {
  IntegrationsResponse,
  ConsentResponse,
  ConsentDecisionPayload,
  ConsentDecisionResponse,
} from '../types/integrations';

export async function getIntegrations(): Promise<IntegrationsResponse> {
  return request<IntegrationsResponse>('/integrations');
}

export async function revokeIntegration(id: string): Promise<{ ok: boolean }> {
  return request<{ ok: boolean }>(`/integrations/${id}/revoke`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export async function getConsentInfo(ticket: string): Promise<ConsentResponse> {
  return request<ConsentResponse>(`/integrations/consent?ticket=${encodeURIComponent(ticket)}`);
}

export async function submitConsent(payload: ConsentDecisionPayload): Promise<ConsentDecisionResponse> {
  return request<ConsentDecisionResponse>('/integrations/consent', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
